<template>
    <span :class="badgeClasses">
        <slot></slot>
        <dk-icon v-if="isArticleBadge" class="tw-ml-2" :name="textColorAndIconName[1]" :size="'xs'" />
        <button v-if="showDismiss" type="button" class="tw-ml-3" @click="dismiss">
            <svg xmlns="http://www.w3.org/2000/svg" class="tw-h-4 tw-w-4" viewBox="0 0 20 20" fill="currentColor">
                <path
                    fill-rule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clip-rule="evenodd"
                />
            </svg>
        </button>
    </span>
</template>

<script>
export default {
    name: 'DkBadgeDST',
    components: {
        DkIcon: () => ({
            component: import(/* webpackChunkName: "DkIcon-vue" */ '@v4/common/components/atoms/DkIcon.vue'),
        }),
    },
    props: {
        size: {
            type: String,
            default: 'default',
            validator(value) {
                return ['default', 'small'].includes(value);
            },
        },
        type: {
            type: String,
            default: 'light',
            validator(value) {
                return ['light', 'dark', 'pink', 'green', 'blue', 'light-blue', 'dark-blue'].includes(value);
            },
        },
        showDismiss: {
            type: Boolean,
            default: false,
        },
        categorySlug: {
            type: String,
            default: null,
        },
        isArticleBadge: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isVisible: true,
        };
    },
    computed: {
        textColorAndIconName() {
            if (!(this.isArticleBadge && this.categorySlug)) {
                return null;
            }

            switch (this.categorySlug) {
                case 'ranking':
                    return ['tw-text-blue-700', 'ds-star-empty'];

                case 'utility':
                    return ['tw-text-teal-700', 'ds-checkmark-empty'];

                case 'classification':
                    return ['tw-text-red-700', 'ds-classification-empty'];

                default:
                    return null;
            }
        },
        badgeClasses() {
            return [
                'tw-inline-flex',
                'tw-items-center',
                'tw-border tw-border-solid',
                'tw-rounded-full',
                'tw-font-semibold',
                this.size === 'small' ? 'tw-px-3 tw-h-6 tw-text-xs' : 'tw-px-4 tw-h-[36px] tw-text-sm',
                { 'tw-border-slate-100 tw-bg-secondary-light': this.type === 'light' },
                { 'tw-bg-secondary-dark': this.type === 'dark' },
                { 'tw-border-[#289194] tw-bg-[#289194]': this.type === 'green' },
                { 'tw-border-[#F94894] tw-bg-[#F94894]': this.type === 'pink' },
                { 'tw-border-brand-primary tw-bg-brand-primary': this.type === 'blue' },
                { 'tw-border-blue-800 tw-bg-blue-700 tw-text-negative': this.type === 'dark-blue' },
                { 'tw-border-blue-200 tw-bg-primary-light tw-text-blue-700': this.type === 'light-blue' },
                { 'tw-text-white': ['pink', 'blue', 'green', 'dark'].includes(this.type) },
                this.isArticleBadge === true ? this.textColorAndIconName[0] : '',
                { 'tw-hidden': !this.isVisible },
            ];
        },
    },
    methods: {
        dismiss() {
            this.isVisible = false;
            this.$emit('dismissed');
        },
    },
};
</script>
